import type { RetainerOptionId } from '@odo/shared-ui';
import apiV2 from '../api/v2';
import { toApiError } from './apiErrors';

export interface SetRetainerOrderResult {
    retainerOption: RetainerOptionId;
    order: string;
}

/** Ret-3: set or correct the retainer order the doctor picked before it is placed. */
export async function setRetainerOrder(
    patientId: string,
    retainerOption: RetainerOptionId
): Promise<SetRetainerOrderResult> {
    try {
        const response = await apiV2.put<{ success: boolean; data: SetRetainerOrderResult }>(
            `/patients/${patientId}/workflow/retention/retainer-order`,
            { retainerOption }
        );
        return response.data.data;
    } catch (err) {
        throw toApiError(err);
    }
}
